// ExperienceComponent.js
import React from 'react';

function ExperienceComponent({ experience, setExperience }) {
  return (
    <div className="mb-4">
      <label className="block text-gray-700 font-bold mb-2">Experience</label>
      <div className="flex space-x-4">
        <input
          type="number"
          value={experience.min}
          onChange={(e) => setExperience({ ...experience, min: e.target.value })}
          className="w-full border rounded-md py-2 px-3 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Min"
        />
        <span className="text-gray-500">to</span>
        <input
          type="number"
          value={experience.max}
          onChange={(e) => setExperience({ ...experience, max: e.target.value })}
          className="w-full border rounded-md py-2 px-3 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Max"
        />
        <span className="text-gray-500">Years</span>
      </div>
    </div>
  );
}

export default ExperienceComponent;
